<template>
  <div class="bk-clipboard-item-file">
    <div class="bk-clipboard-item-file-lines">
      <div
        v-for="n in 10"
        :key="n"
        :style="{
  width: Math.max(Math.min(prng(n + fileSize) * 230, 100), 40) + '%'
}"
      />
    </div>
    <h3>{{ fileName }}</h3>
    <ul>
      <li>{{ extension }}</li>
      <li>{{ fileSizeReadable }}</li>
    </ul>
  </div>
</template>

<script setup>
import { computed } from "#imports";
const props = defineProps({
  type: { type: String, required: true },
  id: { type: String, required: true },
  itemBundle: { type: String, required: true },
  data: { type: String, required: true },
  additional: { type: String, required: true },
  fileName: { type: String, required: true },
  fileSize: { type: Number, required: true },
  fileType: { type: String, required: true }
});
function prng(seed) {
  seed = (seed ^ 1831565813) + (seed << 1);
  seed = seed ^ seed >> 15;
  seed = seed + (seed << 4);
  seed = seed ^ seed >> 13;
  seed = seed * 2246822507;
  seed = seed ^ seed >> 16;
  seed = seed >>> 0;
  return seed / 4294967296;
}
function humanFileSize(bytes, si = false, dp = 1) {
  const thresh = si ? 1e3 : 1024;
  if (Math.abs(bytes) < thresh) {
    return bytes + " B";
  }
  const units = si ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"] : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
  let u = -1;
  const r = 10 ** dp;
  do {
    bytes /= thresh;
    ++u;
  } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);
  return bytes.toFixed(dp) + " " + units[u];
}
const fileSizeReadable = computed(() => humanFileSize(props.fileSize));
const extension = computed(() => {
  return (props.fileType.split("/")[1] || props.fileType || "").toUpperCase();
});
</script>
